import React, {forwardRef} from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './menu.module.styl';

import type {ComponentPropsWithoutRef} from 'react';


const classnames = withCssModule(styles);

type NativeProps = ComponentPropsWithoutRef<'ul'>;

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props extends NativeProps {}

/**
 * List component.
 * Renders a list of menu items.
 */
export const List = forwardRef<HTMLUListElement, Props>(({
    children,
    ...rootProps
}, ref) => (
    <ul
        role="menu"
        {...rootProps}
        ref={ref}
        className={classnames('list', rootProps?.className)}>
        {children}
    </ul>
));

List.displayName = 'List';
